<template>
  <component
    v-bind:is="$data.$_componentName"
    v-bind:shows="$data.$_shows"
    v-bind="$data.$_props"
    v-bind:finalize-callback="$data.$_finalizeCallback"
  >
  </component>
</template>

<script>
import GeneralTextFieldEditor from './Dialogs/GeneralTextFieldEditor.vue';
import TimelineSegmentEditor from './Dialogs/TimelineSegmentEditor.vue';
import TimelineDataFilter from './Dialogs/TimelineDataFilter.vue';
import TimelineDataSelector from './Dialogs/TimelineDataSelector.vue';
import ViewFilter from './Dialogs/ViewFilter.vue';
import HelpMessage from './Dialogs/HelpMessage.vue';
import GeneralConfirmation from './Dialogs/GeneralConfirmation.vue';
import GeneralMessage from './Dialogs/GeneralMessage.vue';
import TimelineViewRangeEditor from './Dialogs/TimelineViewRangeEditor.vue';

export default {
  components: {
    GeneralTextFieldEditor,
    TimelineSegmentEditor,
    TimelineDataFilter,
    TimelineDataSelector,
    ViewFilter,
    HelpMessage,
    GeneralConfirmation,
    GeneralMessage,
    TimelineViewRangeEditor,
  },

  props: {
    commonPreInitializeCallback:  { type: Function },
    commonPostInitializeCallback: { type: Function },
    commonPreFinalizeCallback:    { type: Function },
    commonPostFinalizeCallback:   { type: Function },
  },

  data() {
    return {
      $_componentName: undefined,
      $_props: undefined,
      $_shows: false,
      $_finalizeCallback: undefined,
    };
  },

  methods: {
    async open(componentName, props) {
      return new Promise(resolve => {
        if (this.commonPreInitializeCallback !== undefined) this.commonPreInitializeCallback();
        let finalizeCallback = props.finalizeCallback;
        delete props.finalizeCallback;
        this.$data.$_componentName = componentName;
        this.$data.$_props = props;
        this.$data.$_shows = true;
        if (this.commonPostInitializeCallback !== undefined) this.commonPostInitializeCallback();

        this.$data.$_finalizeCallback = (returnValue) => {
          if (this.commonPreFinalizeCallback !== undefined) this.commonPreFinalizeCallback();
          if (finalizeCallback !== undefined) {
            returnValue = finalizeCallback(returnValue);
          }
          this.$data.$_shows = false;
          if (this.commonPostFinalizeCallback !== undefined) this.commonPostFinalizeCallback();
          resolve(returnValue);
        };
      });
    },
  },
}
</script>
